import * as React from 'react';
import { InputHTMLAttributes } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

interface InputFloatingPlaceholderProps extends InputHTMLAttributes<HTMLInputElement> {
	isValid?: boolean;
	isRequired: boolean;
	showInvalid?: boolean;
	placeholder?: string;
	hasIcon?: boolean;
	inputError?: boolean;
	feedbackMaxLength?: number;
}

export class InputFloatingPlaceholder extends React.Component<InputFloatingPlaceholderProps, {}> {
	private inputTextRef: React.RefObject<HTMLInputElement>;
	constructor(props: InputFloatingPlaceholderProps) {
		super(props);
		this.inputTextRef = React.createRef<HTMLInputElement>();
	}

	render() {
		const { isValid, ...props } = { ...this.props };

		const className = this.props.isValid ? 'comment-success-icon' : 'comment-error-icon';

		return (
			<Container className="input-floating-placeholder-container">
				{this.props.hasIcon ? (
					<>
						<TextInputIcon {...props} placeholder=" " ref={this.inputTextRef} />
						<Placeholder
							className={this.props.inputError ? 'floating-label input-error' : 'floating-label'}
							onClick={() => this.inputTextRef?.current?.focus()}
						>
							{this.props.placeholder}
						</Placeholder>
						{this.props.isValid ? <Icon className={className} /> : null}
						{this.props.inputError ? (
							<p className="four-additional-pictures-mileage-input-error-message">
								<FormattedMessage id="dashboardMileage.input.error"></FormattedMessage>
							</p>
						) : null}
					</>
				) : (
					<>
						<TextInput
							{...props}
							maxLength={this.props.feedbackMaxLength || undefined}
							placeholder=" "
							ref={this.inputTextRef}
						/>
						<Placeholder
							className="floating-label"
							onClick={() => this.inputTextRef?.current?.focus()}
						>
							{this.props.placeholder}
						</Placeholder>
					</>
				)}
			</Container>
		);
	}
}

const Container = styled.div`
	position: relative;
	margin-top: 0.5rem;
`;

const TextInputIcon = styled.input`
	color: #000;
	width: 100%;
	padding: 0.2rem 0.2rem 0.2rem 0.2rem;
	border-bottom: ridge;
	width: 100%;
	-moz-appearance: textfield;
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	font-size: inherit;
	font-family: inherit;
	line-height: inherit;

	transition: 0.2s;
	transition-timing-function: ease;
	transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);

	&:focus + .floating-label,
	&:not(:placeholder-shown) + .floating-label {
		transform: scale(0.75) translateX(-16%);
		top: -70%;
		opacity: 1;
	}

	&:not(:placeholder-shown) {
		width: calc(100% - 3.5rem);
	}

	&:not(:placeholder-shown) ~ .comment-success-icon,
	&:not(:placeholder-shown) ~ .comment-error-icon {
		opacity: 1;
	}
`;

const TextInput = styled.input`
	color: #000;
	width: 100%;
	padding: 0.2rem 0.2rem 0.2rem 0.2rem;
	border-bottom: ridge;
	width: 100%;
	-moz-appearance: textfield;
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	font-size: inherit;
	font-family: inherit;
	line-height: inherit;

	&:focus + .floating-label,
	&:not(:placeholder-shown) + .floating-label {
		transform: scale(0.75) translateX(-16%);
		padding: initial;
		margin: initial;
		top: -80%;
		opacity: 1;
	}
`;

const Placeholder = styled.label`
	position: absolute;
	height: 2rem;
	left: 0%;
	top: 0%;
	padding: 0.2rem 0.2rem 0.2rem 0.2rem;
	transition: 0.2s;
	transition-timing-function: ease;
	transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
	opacity: 0.5;
`;

const Icon = styled.span`
	transition: 0.2s;
	transition-timing-function: ease;
	transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
`;
